// extracted by mini-css-extract-plugin
export default {"menuAnchorButton":"menu-anchor-module__menuAnchorButton__seGkApX"};